import { useLocation, useNavigate, useParams } from "react-router";
import { Loading } from "../../../shared/components";
import { AppShell } from "../../../shared/layout";
import { BuildGraphModal } from "../components/BuildGraphModal";
import { useBuild } from "../hooks/useBuilds";
import "../styles/builds.css";

export function BuildDetailPage({ overlay = false }: { overlay?: boolean }) {
  const { workspaceId, buildId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const detail = useBuild(buildId, workspaceId);
  const returnTo =
    typeof location.state === "object" &&
    location.state !== null &&
    "buildsReturnTo" in location.state &&
    typeof location.state.buildsReturnTo === "string"
      ? location.state.buildsReturnTo
      : `/w/${workspaceId}/builds`;

  if (detail.isLoading && !overlay) {
    return (
      <AppShell>
        <Loading />
      </AppShell>
    );
  }

  const modal = (
    <BuildGraphModal
      detail={detail.data}
      key={buildId}
      loading={detail.isLoading}
      onOpenChange={(open) => {
        if (!open) {
          if (overlay) {
            navigate(-1);
            return;
          }
          navigate(returnTo, { replace: true });
        }
      }}
      open
    />
  );

  return overlay ? modal : <AppShell>{modal}</AppShell>;
}
